import { render, staticRenderFns } from "./RegistrationRoute.vue?vue&type=template&id=e5e66d1a&scoped=true&"
import script from "./RegistrationRoute.vue?vue&type=script&lang=js&"
export * from "./RegistrationRoute.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationRoute.vue?vue&type=style&index=0&id=e5e66d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e66d1a",
  null
  
)

export default component.exports